<template>
	<div :style="iconStyle" class="flex-centerize">
		<v-img eager :src="externalSource" v-if="!hasLocalSvgIcon" />
		<span :style="iconStyle" v-html="iconComponent" v-else-if="!isLoading" />
	</div>
</template>

<script>
import IconService from '@/utils/icon-service';

export default {
	props: {
		name: { type: String, required: true },
		iconColor: { type: String, default: '#2684FF' },
		width: { type: [Number, String] },
		height: { type: [Number, String] },
	},
	computed: {
		externalSource() {
			return IconService.getExternalIconUrl(this.name);
		},
		iconStyle() {
			const { width, height, iconColor } = this;
			return {
				width: width == '100%' ? '100%' : `${width}px`,
				height: `${height}px`,
				color: `${iconColor}`,
			};
		},
		hasLocalSvgIcon() {
			return IconService.hasIcon(this.name);
		},
	},
	methods: {
		async getIconComponent() {
			this.iconComponent = await IconService.getIcon(this.name);
		},
	},
	async created() {
		if (this.hasLocalSvgIcon) {
			this.isLoading = true;
			await this.getIconComponent();
			this.isLoading = false;
		}
	},
	data() {
		return {
			isLoading: false,
			iconComponent: null,
		};
	},
};
</script>
